import { HTMLAttributes, ReactNode } from "react";
import styles from "./Heading.module.css";
import { cx } from "../utils";

export interface TextProps extends HTMLAttributes<HTMLElement> {
    as?: "p" | "span" | "label" | "div";
    variant?: "body" | "caption" | "label" | "kicker";
    tone?: "primary" | "secondary" | "muted";
    children: ReactNode;
}

const variantClasses = {
    body: styles.body,
    caption: styles.caption,
    label: styles.label,
    kicker: styles.kicker
};

const toneClasses = {
    primary: styles.tonePrimary,
    secondary: styles.toneSecondary,
    muted: styles.toneMuted
};

export const Text = ({ as: Component = "p", variant = "body", tone = "primary", className, children, ...props }: TextProps) => (
    <Component className={cx(styles.text, variantClasses[variant], toneClasses[tone], className)} {...props}>
        {children}
    </Component>
);
